// extracted by mini-css-extract-plugin
export default {"grid":"DashboardGrid_grid__2QglA"};